import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Upload } from 'lucide-react';
import { Dialog, DialogContent } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import ALLOWED_TYPES from './AllowedTypes';
import { RouteParams } from '../library/types';
import { uploadFiles } from './uploadSlice';

const UploadModal = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  const { teamId, folderId } = useParams<RouteParams>();
  const dispatch = useDispatch();

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const { files } = event.dataTransfer;
    if (teamId && folderId && files) {
      const filesArray = Array.from(files);
      const filteredFiles = filesArray.filter((file) =>
        ALLOWED_TYPES.includes(file.type),
      );
      dispatch(uploadFiles({ teamId, folderId, files: filteredFiles }));
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent
        className="flex flex-col justify-center items-center min-h-[15rem] sm:min-h-[20rem] rounded-lg text-center p-4 bg-background"
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
      >
        <Upload className="h-8 w-8 sm:h-10 sm:w-10 mb-4 text-muted-foreground" />
        <h2 className="text-lg font-semibold mb-4 max-w-full break-words">
          {t('upload.modal.title')}
        </h2>
        <Button
          onClick={() => document.getElementById('file-input')?.click()}
          data-testid="upload-file-button-upload-modal"
        >
          {t('upload.modal.uploadFile')}
        </Button>
        <input
          id="file-input"
          data-testid="file-input"
          type="file"
          multiple
          accept={ALLOWED_TYPES.join(',')}
          className="hidden"
          onChange={(event) => {
            if (teamId && folderId && event.target.files) {
              const filesArray = Array.from(event.target.files);
              const filteredFiles = filesArray.filter((file) =>
                ALLOWED_TYPES.includes(file.type),
              );
              dispatch(uploadFiles({ teamId, folderId, files: filteredFiles }));
              onClose();
            }
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UploadModal;
